<template>
   <b-overlay :show="true" rounded="sm" no-fade>
      <div class="login"></div>
   </b-overlay>
</template>

<script>
import SdkMixins from "@/mixins/SdkMixins";
export default {
   name: "LoginPage",
   mixins: [SdkMixins],
   props: {},
   data() {
      return {};
   },
   mounted() {
      this.init();
   },
   beforeDestroy() {
      this.$cookies.remove("before_login_path");
   },
   computed: {},
   methods: {
      async init() {
         const { e, expires_in, source } = this.$route.query;
         await this.login({
            beliveId: e.replace(/\s/g, "+"),
            signInType: source === "japan" ? 0 : 1,
            expires: expires_in
         });
         let redirectRouteName = localStorage.getItem("redirect_route_name");
         let redirectRouteParams = localStorage.getItem("redirect_route_params");
         let redirectRouteQuery = localStorage.getItem("redirect_route_query");
         localStorage.removeItem("redirect_route_name");
         localStorage.removeItem("redirect_route_params");
         localStorage.removeItem("redirect_route_query");
         this.$router.push({
            name: redirectRouteName,
            params: JSON.parse(redirectRouteParams || {}),
            query: JSON.parse(redirectRouteQuery || {})
         });
      }
   }
};
</script>

<style lang="scss" scoped>
.login {
   width: 100%;
   height: $view-height;
   margin-top: 90px;
}
</style>
